var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',{attrs:{"name":_vm.name,"label":_vm.label,"as-row":_vm.asRow,"size":_vm.size}},[_c('p',_vm._b({staticClass:"form-control-plaintext",class:_vm.inputClass},'p',_vm.$attrs,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }